import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from "firebase/firestore";
import { ProspectNote } from "../leads/prospects";

const serializeCreatedAt = (d: Date): string =>
  d instanceof Date && !Number.isNaN(d.getTime()) ? d.toISOString() : new Date().toISOString();

export const prospectNoteConverter: FirestoreDataConverter<ProspectNote> = {
  toFirestore(note: ProspectNote) {
    const { id: _id, ...data } = note;
    return {
      prospectId: data.prospectId ?? "",
      note: data.note ?? "",
      createdByUserId: data.createdByUserId ?? "",
      createdAt: serializeCreatedAt(data.createdAt),
    };
  },

  fromFirestore(snapshot: QueryDocumentSnapshot, options?: SnapshotOptions): ProspectNote {
    const data = snapshot.data(options);
    const raw = data?.createdAt;
    let createdAt: Date;
    if (raw instanceof Timestamp) {
      createdAt = raw.toDate();
    } else if (typeof raw === "string") {
      createdAt = new Date(raw);
    } else {
      createdAt = new Date();
    }
    if (Number.isNaN(createdAt.getTime())) {
      createdAt = new Date();
    }

    return {
      id: snapshot.id,
      prospectId: typeof data?.prospectId === "string" ? data.prospectId : "",
      note: typeof data?.note === "string" ? data.note : "",
      createdByUserId:
        typeof data?.createdByUserId === "string" ? data.createdByUserId : "",
      createdAt,
    };
  },
};
